import { Injectable } from '@angular/core';
import { ActivitiesAggrigatorModel } from '@shared/model/activities-aggrigator-model';
import { ObjectTypeEnum } from '@shared/model/enum/object-type-enum';
import { INotifTextStrategy } from '../model/notification.model';

@Injectable({
  providedIn: 'root'
})
export class CommentNotifStrategy implements INotifTextStrategy {
  public createText(activity: ActivitiesAggrigatorModel, receiver: string, isFireBaseContext: boolean): string {
    const affectedUserId = activity?.affectedUser?.id;
    const carried = activity?.carried?.data;
    const actorName = isFireBaseContext ? activity?.actor?.fullName ?? '' : '';


    //? Reply or mention on someone else's content
    if (affectedUserId !== receiver && carried?.mentions?.length) {
      return this.getMentionOrReplyMessage(activity, receiver, actorName);
    }
    //? Comment on my own content
    else {
      return this.getOwnContentMessage(activity!, actorName)
    }

  }



  // Generates text for user's own content (Review, Quote, Progress, etc.)
  private getOwnContentMessage(activity: ActivitiesAggrigatorModel, actorName: string): string {
    const objectType = activity?.inDirectObject?.objectType;
    const data = activity?.inDirectObject?.data;

    switch (objectType) {
      case ObjectTypeEnum.Review:
        {
          const hasBody = data?.body?.length > 0;
          const hasRate = data?.rate > 0;
          return !hasBody && hasRate ? `${actorName} زیر امتیاز شما نظری نوشت.` : `${actorName} زیر یادداشت شما نظری نوشت.`
        };

      case ObjectTypeEnum.Quote:
        return `${actorName} زیر بریدۀ کتاب شما نظری نوشت.`;

      case ObjectTypeEnum.Progress:
        {
          const steps = data?.steps;
          const total = data?.totalPages;
          return steps >= 0 && steps < total
            ? `${actorName} زیر گزارش مطالعه شما نظری نوشت.`
            : `${actorName} زیر تغییر وضعیت شما نظری نوشت.`
        };

      case ObjectTypeEnum.Post:
        return `${actorName} زیر پست شما نظری نوشت.`;

      case ObjectTypeEnum.Booklist:
        return `${actorName} زیر لیست شما نظری نوشت.`;

      case ObjectTypeEnum.Club:
        return `${actorName} زیر شروع به کار باشگاه شما نظری نوشت.`;

      case ObjectTypeEnum.UserChallenge:
        {
          const isCompleted =
            data?.totalSteps ===
            data?.currentStep;
          const txt = isCompleted ? `زیر اتمام این چالش نظری نوشت.` : `زیر پیوستن به این چالش نظری نوشت.`;
          return `${actorName} ${txt}`
        };


      case ObjectTypeEnum.badge:
        return `${actorName} زیر کسب دستاورد شما نظری نوشت.`;

      case ObjectTypeEnum.UserReportPublished:
        return `${actorName} زیر گزارش سالیانه‌ی شما نظری نوشت.`;

      default:
        return '';
    }
  }
  // Generates text for mentions or replies on other users' content
  private getMentionOrReplyMessage(activity: ActivitiesAggrigatorModel, receiver: string, actorName: string): string {
    const carried = activity?.carried?.data;

    const mention = carried?.mentions?.find((m: { userId?: string }) => m.userId === receiver);

    if (!mention) return '';

    return carried?.objectType === ObjectTypeEnum.Message
      ? `${actorName} در پاسخ به دیدگاه شما نظری نوشت.`
      : `${actorName} از شما در یک نظر نام برد.`;
  }

}
